import _ from "lodash";

export function getObjectFromList(listOfObjects, nameOfKey) {
  let searchedObject = null;
  for (let i = 0; i < listOfObjects.length; i++) {
    if (listOfObjects[i][nameOfKey]) {
      searchedObject = listOfObjects[i][nameOfKey];
      break;
    }
  }
  return searchedObject;
}

export function getObjectFromListByValue(listOfObjects, nameOfKey, value) {
  let searchedObject = null;
  for (let i = 0; i < listOfObjects.length; i++) {
    if (listOfObjects[i][nameOfKey] === value) {
      searchedObject = listOfObjects[i];
      break;
    }
  }
  return searchedObject;
}

export function isTypeRelevant(type, listOfTypes) {
  let relevant = false;
  for (let i = 0; i < listOfTypes.length; i++) {
    if (listOfTypes[i] === type) {
      relevant = true;
      break;
    }
  }
  return relevant;
}

export function transformStaticTableDataForChart(column) {
  let res = {};
  res.title = column[0]?.title;
  res.data = [];
  column.forEach((ans) => {
    let clone = _.cloneDeep(ans.data[0]);
    clone.xaxisValue = ans.title;
    res.data.push(clone);
  });
  return res;
}

export function getAllRowIdentifiersOfStaticTable(table) {
  let res = [];
  const fn = _.spread(_.union);

  res = table.map((obj) => {
    return obj.map((sub) => {
      return sub.zaxisValue;
    });
  });

  return fn(res);
}

export function getSubQuestionModifiedId(questionId, identifier, rowId, colId) {
  let subquestionModifiedId;

  // lookup if we have an identifer supplied otherwise take row/colIDs
  if (identifier && identifier !== "") {
    subquestionModifiedId = questionId.toString() + identifier;
  } else {
    if ((rowId !== undefined && rowId !== null) || (colId !== undefined && colId !== null)) {
      subquestionModifiedId =
        questionId.toString() + (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0");
    } else {
      subquestionModifiedId = questionId;
    }
  }

  return String(subquestionModifiedId);
}
